import React from 'react';
import { Outlet } from "react-router-dom";
import './App.css';
import MenuLayout from "./layout/MenuLayout";
import HeaderLayout from "./layout/HeaderLayout";
import FooterLayout from "./layout/FooterLayout";
import 'bootstrap/dist/css/bootstrap.min.css';
import { useAppSelector } from './redux/hooks';
import { menuState } from './redux/slice/MenuSlice';

function App() {

  const menu = useAppSelector(menuState);

  return (
    <div id="body">
        <MenuLayout />
        <div className="overlay"></div>
        <main className={`main-wrapper ${menu.active ? 'active' : ''}`}>
            <HeaderLayout />
            <section>
              <Outlet />
            </section>
            <FooterLayout />
        </main>
    </div>
  );
}

export default App;